import React from 'react'
import { i18n } from '../../index'
import { alphaSort } from '../../../common/utils'
import { Paper, Table, TableBody } from '@mui/material'
import NightTaskRow from './NightTaskRow'
import { fetchNightTasks } from '../../station/stationQueries'
import type { NightTask } from '../../station/stationTypes'
import css from './nightTaskTable.css'

const updateCacheOnDelete = (query: any, variables: any, filterFn: (...args: Array<any>) => any) => (cache: any) => {
  const { stationNightTasks } = cache.readQuery({
    query,
    variables,
  })
  cache.writeQuery({
    query,
    variables,
    data: {
      stationNightTasks: stationNightTasks.filter(filterFn),
    },
  })
}

type NightTaskTableProps = {
  data: Array<NightTask>
  stationId: string
  onEdit: (...args: Array<any>) => any
}

class NightTaskTable extends React.PureComponent<NightTaskTableProps> {
  onDelete = (onMutate: (...args: Array<any>) => any, nightTaskId: string) => {
    const { stationId } = this.props
    onMutate({
      variables: {
        nightTaskId,
      },
      update: updateCacheOnDelete(
        fetchNightTasks,
        {
          stationId,
        },
        (item) => item.id !== nightTaskId,
      ),
    })
  }

  render() {
    const { data, onEdit } = this.props
    return (
      <Paper>
        <div className={css.component}>
          <Table>
            <TableBody>
              {data.length ? (
                alphaSort('name', data).map((item) => (
                  <NightTaskRow data={item} onEdit={onEdit} onDelete={this.onDelete} key={item.id} />
                ))
              ) : (
                <tr>
                  <td>
                    <p className={css.empty}>{i18n.t('admin.stations.noNightTasks')}</p>
                  </td>
                </tr>
              )}
            </TableBody>
          </Table>
        </div>
      </Paper>
    )
  }
}

export default NightTaskTable
